import filterAndSortRelatedPosts from '../../utilities/filterAndSortRelatedPosts'
import { defaults } from './Constants';

const gridPropsTransformer = ({ 
    databaseId, 
    relatedPosts, 
    pinnedPosts={ edges:[] }, 
    handlePageChange, 
    currentPage, 
    totalFound,
    gridLimit = 15
}) =>
{
    const postsRelated = filterAndSortRelatedPosts(
        databaseId,
        relatedPosts?.edges || [],
        pinnedPosts?.edges || []
    )

    return {
        ...defaults.gridProps,
        queryArgs: {
            posts: postsRelated,
            total_found: postsRelated.length,
        },
        gridLimit,
        pageCount: Math.ceil(postsRelated.length / gridLimit),
        showControl: true,
        handlePageChange,
        currentPage,
        totalFound
    }
}

export default gridPropsTransformer;
